"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _jsxRuntime = require("react/jsx-runtime");

var Controls = function Controls(_ref) {
  var map = _ref.map,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: children
  });
};

var _default = Controls;
exports.default = _default;